(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('SoggettoEsternoDeleteController',SoggettoEsternoDeleteController);

    SoggettoEsternoDeleteController.$inject = ['$uibModalInstance', 'entity', 'SoggettoEsterno'];

    function SoggettoEsternoDeleteController($uibModalInstance, entity, SoggettoEsterno) {
        var vm = this;

        vm.soggettoEsterno = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SoggettoEsterno.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
